// extracted by mini-css-extract-plugin
module.exports = {"h1":"ErrorDisplay_h1__3hIda","h2":"ErrorDisplay_h2__3b900","p":"ErrorDisplay_p__1DGoO"};